import { Route, Routes } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import { useT } from '../../../../_metronic/i18n/Metronici18n'
import { ComparacaoProtocoloPage } from './comparacao/ComparacaoProtocoloPage'
import { ModeloPlataformaComparacaoPage } from './modelo/modelo-plataforma-comparacao/ModeloPlataformaComparacaoPage'
import { ModeloPlataformaDetalhePage } from './modelo/modelo-plataforma-detalhe/ModeloPlataformaDetalhePage'
import { ModeloPlataformaList } from './modelo/modelo-plataforma-list/ModeloPlataformaList'
import { ModeloPublicadoPage } from './modelo/modelo-publicado/ModeloPublicadoPage'
import { ProtocoloDetalhePage } from './detalhe/ProtocoloDetalhePage'
import { ProtocolosTriagemList } from './protocolos-triagem-list/ProtocolosTriagemList'

const breadcrumbs: Array<PageLink> = [
  {
    title: 'Protocolos de Triagem',
    path: '/apps/protocolos-triagem',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ProtocolosTriagemPage = () => {
  const { t } = useT()
  return (
    <Routes>
      <Route
        path=''
        element={
          <>
            <PageTitle description={t('pagina.protocolosTriagem.descricao')}>
              Protocolos de Triagem
            </PageTitle>
            <ProtocolosTriagemList />
          </>
        }
      />
      <Route
        path='modelo'
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs}>Modelo Lauduz</PageTitle>
            <ModeloPublicadoPage />
          </>
        }
      />
      <Route
        path='modelo-plataforma'
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs}>Modelo da plataforma</PageTitle>
            <ModeloPlataformaList />
          </>
        }
      />
      <Route
        path='modelo-plataforma/:id'
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs}>Versão do modelo</PageTitle>
            <ModeloPlataformaDetalhePage />
          </>
        }
      />
      <Route
        path='modelo-plataforma/:id/comparar'
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs}>Comparar versões do modelo</PageTitle>
            <ModeloPlataformaComparacaoPage />
          </>
        }
      />
      <Route
        path=':id'
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs}>Versão do protocolo</PageTitle>
            <ProtocoloDetalhePage />
          </>
        }
      />
      <Route
        path=':id/comparar'
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs}>Comparar versões</PageTitle>
            <ComparacaoProtocoloPage />
          </>
        }
      />
    </Routes>
  )
}

export default ProtocolosTriagemPage
